import { css } from 'styled-components';

export const cssDefaultInline = css`
  color: ${({ theme }) => theme.colors.magenta700};
  border-width: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.magenta700};
  }

  &[disabled] {
    background-color: ${({ theme }) => theme.colors.gray900};
    color: ${({ theme }) => theme.colors.gray800};
    opacity: 1;
  }
`;
